























































































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import { db, auth, busy, VIPContact, IVIPContact, VIPContactRest, ICapabilities, toaster, getVipContactCivilityList, DBType } from "@/loader/public";
// import EntityEdit from "@/component/EntityEdit";
import { VIPContactEditComponentMixin } from "@/mixins/VIPContactMixin";

@Component
export default class ContactEdit extends Mixins(VIPContactEditComponentMixin) {
	// @Prop({ type: VIPContact, required: true })
	// public item!: VIPContact;

	// public rest = VIPContactRest;
	// public dbType = DBType.contacts;
	// public loadMessage = "Chargement du contact ...";
	// public editCap = "edit_vip_contact";
	// public deleteCap = "delete_vip_contact";
	// public focused = {
	// 	last_name: false,
	// 	first_name: false,
	// 	position: false,
	// 	email: false,
	// 	phone: false,
	// };
	// public invalidFeedbacks = {
	// 	last_name: "Le nom ne peut pas être vide et ne doit pas dépasser 255 caractères",
	// 	first_name: "Le prénom ne doit pas dépasser 255 caractères",
	// 	position: "Le poste ne doit pas dépasser 255 caractères",
	// 	email: "L'adresse email doit être valide et ne doit pas dépasser 255 caractères",
	// 	phone: "Le numéro de téléphone ne peut contenir que des chiffres ou les caractères spéciaux suivants : . - + ( ) ou espace et ne doit pas dépasser 50 caractères",
	// };

	// public get states(): { [prop in keyof IVIPContact]: boolean | null } {
	// 	return {
	// 		last_name: this.focused.last_name ? this.item.last_name.length > 0 && this.item.last_name.length <= 255 : null,
	// 		first_name: this.focused.first_name ? !this.item.first_name || this.item.first_name.length <= 255 : null,
	// 		position: this.focused.position ? !this.item.position || this.item.name.length <= 255 : null,
	// 		email: this.focused.email ? (!this.item.email || (this.item.email.length <= 255 && /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(this.item.email))) : null,
	// 		phone: this.focused.phone ? (!this.item.phone || (this.item.phone.length <= 50 && /^\+?[0-9 \.\(\)-]+$/.test(this.item.phone))) : null,
	// 	};
	// }

	public get civilities(): any[] {
		return getVipContactCivilityList();
	}

	public unmount() {
		if (this.changed) {
			this.cancel();
		}
	}
}
